import GroupPanel from "./GroupPanel";

// "Passend für dich" — target audiences; no point data, only toggles map
// overlay layers (see layers/overlayLayerRegistry.js)
const groupModule = {
  fallbackLabel: "Zielgruppe",
  Panel: GroupPanel,
};

export default groupModule;
